import type { DirectoryTagKind, DirectoryTagView } from '@chukua/common';
import { api } from '../../../../shared/shared.api';

export type { DirectoryTagKind, DirectoryTagView };

export function listDirectoryTags(kind: DirectoryTagKind): Promise<DirectoryTagView[]> {
  return api<DirectoryTagView[]>(`/directory-tags?kind=${kind}`);
}

export function createDirectoryTag(kind: DirectoryTagKind, name: string): Promise<DirectoryTagView> {
  return api<DirectoryTagView>('/directory-tags', { method: 'POST', body: JSON.stringify({ kind, name }) });
}

export function renameDirectoryTag(id: string, name: string): Promise<DirectoryTagView> {
  return api<DirectoryTagView>(`/directory-tags/${id}`, { method: 'PATCH', body: JSON.stringify({ name }) });
}

export async function deactivateDirectoryTag(id: string): Promise<void> {
  await api<void>(`/directory-tags/${id}/deactivate`, { method: 'POST' });
}

export async function reactivateDirectoryTag(id: string): Promise<void> {
  await api<void>(`/directory-tags/${id}/reactivate`, { method: 'POST' });
}
